<template>
  <div>
    <a-row :gutter="16" style="margin-bottom: 16px;">
      <a-col :span="6">
        <a-card><a-statistic title="溯源码总数" :value="summary.code_quantity" /></a-card>
      </a-col>
      <a-col :span="6">
        <a-card><a-statistic title="累计扫码次数" :value="summary.scan_quantity"
          :value-style="{ color: '#1890ff' }" /></a-card>
      </a-col>
      <a-col :span="6">
        <a-card><a-statistic title="今日扫码" :value="summary.today_scan_quantity"
          :value-style="{ color: '#3f8600' }" /></a-card>
      </a-col>
      <a-col :span="6">
        <a-card><a-statistic title="已被扫描的码数" :value="summary.scanned_code_quantity" /></a-card>
      </a-col>
    </a-row>

    <a-card title="扫码次数排行" style="margin-bottom: 16px;">
      <div slot="extra">
        <a-radio-group v-model="dimension" size="small" @change="loadRanking">
          <a-radio-button value="product">按产品</a-radio-button>
          <a-radio-button value="batch">按批次</a-radio-button>
          <a-radio-button value="code">按溯源码</a-radio-button>
          <a-radio-button value="region">按地区</a-radio-button>
        </a-radio-group>
      </div>
      <a-table size="small" :columns="rankingColumns" :dataSource="ranking" rowKey="value"
        :loading="rankingLoading" :pagination="false">
        <div slot="rank" slot-scope="value, item, index">
          <a-tag :color="['gold', 'orange', 'red'][index] || ''">{{ index + 1 }}</a-tag>
        </div>
        <div slot="bar" slot-scope="value, item">
          <a-progress :percent="percent(item.scan_count)" :showInfo="false" />
        </div>
      </a-table>
      <a-empty v-if="!rankingLoading && ranking.length === 0" />
    </a-card>

    <a-card title="扫码明细">
      <a-row gutter="16">
        <a-col :span="24" style="max-width: 220px; margin-bottom: 12px;">
          <a-select v-model="recordForm.batch" placeholder="按批次筛选" allowClear style="width: 100%" @change="searchRecords">
            <a-select-option v-for="b in batches" :key="b.id" :value="b.id">
              {{ b.product_name }} ({{ b.batch_number }})
            </a-select-option>
          </a-select>
        </a-col>
        <a-col :span="24" style="max-width: 380px; margin-bottom: 12px;">
          <a-range-picker show-time valueFormat="YYYY-MM-DD HH:mm:ss" @change="onRangeChange" style="width: 100%" />
        </a-col>
        <a-col :span="24" style="width: 100px; margin-bottom: 12px;">
          <a-button type="primary" icon="search" @click="searchRecords">查询</a-button>
        </a-col>
      </a-row>
      <a-table size="small" :columns="recordColumns" :dataSource="records" rowKey="id" :loading="recordLoading"
        :pagination="recordPagination" @change="recordTableChange" :scroll="{ x: 900 }" />
    </a-card>
  </div>
</template>

<script>
  import { traceStatSummary, traceStatRanking, scanRecordList, traceBatchList } from '@/api/trace'

  export default {
    name: 'TraceStatistics',
    data() {
      return {
        summary: { code_quantity: 0, scan_quantity: 0, today_scan_quantity: 0, scanned_code_quantity: 0 },

        dimension: 'product',
        ranking: [],
        rankingLoading: false,
        rankingColumns: [
          { title: '排名', dataIndex: 'rank', scopedSlots: { customRender: 'rank' }, width: 80 },
          { title: '名称', dataIndex: 'name' },
          { title: '占比', dataIndex: 'bar', scopedSlots: { customRender: 'bar' }, width: 220 },
          { title: '扫码次数', dataIndex: 'scan_count', width: 120 },
        ],

        recordForm: { batch: undefined, start_time: undefined, end_time: undefined, page: 1, page_size: 16 },
        records: [],
        recordLoading: false,
        recordPagination: { current: 1, total: 0, pageSize: 16 },
        recordColumns: [
          { title: '序号', dataIndex: 'index', customRender: (v, item, index) => index + 1, width: 60 },
          { title: '溯源码', dataIndex: 'code_value' },
          { title: '产品名称', dataIndex: 'product_name' },
          { title: '批号', dataIndex: 'batch_number' },
          { title: '访客IP', dataIndex: 'ip' },
          { title: 'IP归属地', dataIndex: 'location' },
          { title: '扫描时间', dataIndex: 'scan_time' },
        ],
        batches: [],
      };
    },
    computed: {
      maxScan() {
        return this.ranking.reduce((max, item) => Math.max(max, item.scan_count), 0) || 1;
      },
    },
    methods: {
      percent(value) {
        return Math.round((value / this.maxScan) * 100);
      },
      loadSummary() {
        traceStatSummary().then(data => {
          this.summary = data;
        });
      },
      loadRanking() {
        this.rankingLoading = true;
        traceStatRanking({ dimension: this.dimension, limit: 10 }).then(data => {
          this.ranking = data;
        }).finally(() => {
          this.rankingLoading = false;
        });
      },
      loadBatches() {
        traceBatchList({ page_size: 999 }).then(data => {
          this.batches = data.results;
        });
      },
      loadRecords() {
        this.recordLoading = true;
        scanRecordList(this.recordForm).then(data => {
          this.recordPagination.total = data.count;
          this.records = data.results;
        }).finally(() => {
          this.recordLoading = false;
        });
      },
      onRangeChange(value) {
        this.recordForm.start_time = value && value.length ? value[0] : undefined;
        this.recordForm.end_time = value && value.length ? value[1] : undefined;
      },
      searchRecords() {
        this.recordForm.page = 1;
        this.recordPagination.current = 1;
        this.loadRecords();
      },
      recordTableChange(pagination) {
        this.recordForm.page = pagination.current;
        this.recordPagination.current = pagination.current;
        this.loadRecords();
      },
    },
    mounted() {
      this.loadSummary();
      this.loadRanking();
      this.loadBatches();
      this.loadRecords();
    },
  }
</script>
